import React, { createContext, useMemo, useState, useContext } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { DEFAULT_THEME_COLOR } from 'config';

const ThemeContext = createContext();

export const ThemeProviderWrapper = ({ children }) => {
    
    const [bgColor, setBgColor] = useState(localStorage.getItem("theme_color") || DEFAULT_THEME_COLOR); // Default background color

    // Dynamically create the theme
    const theme = useMemo(
        () =>
            createTheme({
                customSettings: {
                    themeColor: bgColor
                },
            }),
        [bgColor]
    );

    return (
        <ThemeContext.Provider value={{ setBgColor }}> {/* Allows changing color dynamically */}
            <ThemeProvider theme={theme}>
                <CssBaseline /> {/* Ensures global styles apply */}
                {children}
            </ThemeProvider>
        </ThemeContext.Provider>
    );
};

// Custom hook to change theme color
export const useThemeContext = () => useContext(ThemeContext);
